import './Checkbox.css';
export default {
    "root": "Checkbox_root__1mvoz",
    "large": "Checkbox_large__1mvoz",
    "small": "Checkbox_small__1mvoz",
    "input": "Checkbox_input__1mvoz",
    "label": "Checkbox_label__1mvoz",
    "background": "Checkbox_background__1mvoz",
    "checkmark": "Checkbox_checkmark__1mvoz",
    "foreground": "Checkbox_foreground__1mvoz",
    "delegate": "Checkbox_delegate__1mvoz"
};
